import React, { useEffect } from "react";
import styles from "./characteristicCustomForm.module.scss";
import { TextField, MultiSelect } from "../../primary";

const EXCLUDED_KEYS = ["other", "noneoftheabove", "alloftheabove"];

export function CharacteristicCustomFormMultiSelect({
  data,
  index,
  optionData,
  getForm,
  register,
  errors,
  setValue,
  clearErrors,
  addItemMultiselect,
  showViewForm,
  optionLevelbranching,
  customFormBuilder,
  checkBranch,
  setFormChangesConfirm,
}) {
  const viewForm = getForm?.formdata?.length > 0 && [...getForm.formdata].find((v) => v.id === data.id);
  const findOthers = viewForm?.options?.find((v) => v === "other");

  useEffect(() => {
    register(`${data.id}`, {
      required: data?.isMandatory === 1 ? "This field is required" : false,
    });
    setValue(`${data.id}`, viewForm?.options?.length > 0 ? viewForm?.options : "", {
      shouldValidate: true,
      shouldDirty: true,
    });
    register(`${data.id}-other`, {
      required: findOthers && data?.isMandatory === 1 ? "This field is required" : false,
    });

    if (viewForm?.value !== undefined) {
      setValue(`${data.id}-other`, viewForm?.value, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  }, [data.id, data?.isMandatory, findOthers, register, setValue, viewForm?.options, viewForm?.value]);

  const onSelectOrg = (selectedList, selectedItem) => {
    setFormChangesConfirm(true);
    addItemMultiselectVal(selectedList, index, selectedItem, data.id);
    setValue(`${data.id}`, selectedList.length > 0 ? selectedList : "", {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };
  const removeItem = (selectedList, removedItem) => {
    setFormChangesConfirm(true);
    removeItemMultiSelectVal(selectedList, index, removedItem, data.id);
    setValue(`${data.id}`, selectedList.length > 0 ? selectedList : "", {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };
  // multiselect select
  const addItemMultiselectVal = (selectedList, index, selectedItem, id) => {
    let selectList = [];

    if (!EXCLUDED_KEYS.includes(selectedItem.key)) {
      selectList = selectedList.filter((val) => !EXCLUDED_KEYS.includes(val.key)).map((val) => val.key);
    } else {
      selectList = [selectedItem.key];
    }

    let forms = customFormBuilder && [...customFormBuilder];
    let formobj = { ...forms[index] };
    let findGotoNum = formobj.options.find((o) => o.key === selectedItem.key);
    let branchNumber = checkBranch(findGotoNum, index);
    const formData = getForm?.formdata ?? [];

    const selectedIndex = formData.findIndex((x) => x.id === id);
    const viewForm = selectedIndex !== -1 ? formData[selectedIndex] : null;

    if (viewForm) {
      const viewData = {
        ...viewForm,
        options: selectList,
      };

      const viewFrm = [...formData];
      viewFrm.splice(selectedIndex, 1, viewData);

      addItemMultiselect({
        ...getForm,
        formdata: viewFrm,
      });
    } else {
      addItemMultiselect({
        ...getForm,
        formdata: [...formData, { id, options: selectList, value: "" }],
      });
    }
    branchNumber !== "" && optionLevelbranching(selectedItem.key, index, id, forms, branchNumber);
  };

  // multiselect remove
  const removeItemMultiSelectVal = (selectedList, index, removedItem, id) => {
    let selectList = [];
    selectedList.map((val, index) => {
      selectList = [...selectList, val.key];
    });
    let lastIndex = selectedList[selectedList.length - 1];
    let forms = customFormBuilder && [...customFormBuilder];
    let formobj = { ...forms[index] };
    let branchNumber = "";
    if (lastIndex !== undefined) {
      let findGotoNum = formobj.options.find((o) => o.key === lastIndex.key);
      branchNumber = checkBranch(findGotoNum, index);
    } else {
      if (formobj.goto !== "" && formobj.goto !== null) {
        branchNumber = checkBranch(formobj, index);
      } else {
        if (formobj.options != null && formobj.options.length > 0) {
          formobj.options.map((opt, optind) => {
            if (branchNumber === "next" || branchNumber === "") {
              branchNumber = checkBranch(opt, index);
            }
          });
        }
      }
    }
    if (showViewForm?.formdata?.length > 0) {
      let viewData = { ...getForm.formdata[index] };
      viewData.options = selectList;
      let dataform = { ...getForm };
      let viewFrm = [...getForm.formdata];
      viewFrm.splice(index, 1, viewData);
      dataform.formdata = viewFrm;
      addItemMultiselect(dataform);
    } else {
      let viewForm = getForm?.formdata?.length > 0 && [...getForm.formdata].find((v) => v.id === id);
      let selectedIndex = getForm?.formdata?.length > 0 && [...getForm.formdata].findIndex((x) => x.id === id);
      if (viewForm) {
        let viewData = { ...viewForm };
        viewData.options = selectList;
        let dataform = { ...getForm };
        let viewFrm = [...getForm.formdata];
        viewFrm.splice(selectedIndex, 1, viewData);
        dataform.formdata = viewFrm;
        addItemMultiselect(dataform);
      }
    }
    branchNumber !== "" && optionLevelbranching(removedItem.key, index, id, forms, branchNumber);
  };

  const getOtherValue = (e, index) => {
    setValue(`${data.id}-other`, e.target.value, {
      shouldValidate: true,
      shouldDirty: true,
    });
    clearErrors(`${data.id}-other`);

    const formData = getForm?.formdata ?? [];
    let updatedFormData = [...formData];

    if (showViewForm?.formdata?.length > 0 && index > -1) {
      updatedFormData[index] = { ...updatedFormData[index], value: e.target.value };
    } else {
      const selectedIndex = formData.findIndex((x) => x.id === data?.id);
      if (selectedIndex !== -1) {
        updatedFormData[selectedIndex] = { ...updatedFormData[selectedIndex], value: e.target.value };
      } else {
        updatedFormData.push({ id: data?.id, value: e.target.value });
      }
    }

    addItemMultiselect({ ...getForm, formdata: updatedFormData });
  };

  return (
    <div key={index}>
      <>
        <input
          type="hidden"
          ref={register(`${data.id}`, {
            required: data?.isMandatory === 1 ? "This field is required" : false,
          })}
        />
        <MultiSelect
          id={`${data.id}`}
          name={`${data.id}`}
          label={`${data.desc}`}
          classes={{
            column: `row ${styles.col_spec}`,
            inputClassName: styles.basic_select,
            labelClassName: `col-6 col-form-label ${styles.label_spec}`,
            inputColumn: `col-5 p-0 ${styles.select_wrapper} multiselectorg`,
          }}
          optionValue={optionData}
          showCheckbox={true}
          displayValue="value"
          onSelect={onSelectOrg}
          onRemove={removeItem}
          defaultValue={viewForm?.options}
          labelSubText={"Select all that apply"}
          required={data?.isMandatory === 1}
          errors={errors}
        />
      </>
      {findOthers && (
        <TextField
          id={`${data.id}-other`}
          name={`${data.id}-other`}
          classes={{
            column: `col-12 ${styles.col_spec}`,
            inputColumn: `offset-6 col-5 p-0 d-flex flex-column`,
            inputClassName: `${styles.basic_input} getOtherval`,
          }}
          type="text"
          validator={register(`${data.id}-other`, {
            required: findOthers && data?.isMandatory === 1 ? "This field is required" : false,
          })}
          errors={errors}
          defaultValue={viewForm.value || ""}
          onChange={(e) => getOtherValue(e, index)}
          required={data?.isMandatory === 1}
        />
      )}
    </div>
  );
}
